export type AudioPlaybackRate = 1 | 1.5 | 2;

export const MAX_REC_TIME_LIMIT_MS = 2 * 60 * 60 * 1000; // 2h
